export default function WhatWeDo() {
  return (
    <section className="bg-white py-24">
      <div className="max-w-[1200px] mx-auto px-20">
        <div className="text-center mb-16">
          <span className="text-xs font-semibold text-gray-500 uppercase tracking-[0.15em] mb-4 block">What We Do</span>
          <h2 className="text-5xl font-bold text-gray-900 mb-6" style={{ fontFamily: 'Crimson Pro, serif' }}>
            Strategic AI systems built around your operations
          </h2>
          <p className="text-lg text-gray-600 max-w-[800px] mx-auto">
            We design, deploy, and maintain AI-powered workflows that reduce operational friction, improve decision-making, and support long-term growth.
          </p>
        </div>

        <div className="grid grid-cols-2 gap-8 mb-12">
          <div className="relative h-[320px] rounded-2xl overflow-hidden">
            <img 
              src="https://public.readdy.ai/ai/img_res/09650156e4cb3ac6b9b334fc9f642fab.jpg"
              alt="AI workflow automation"
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div className="relative h-[320px] rounded-2xl overflow-hidden">
            <img 
              src="https://readdy.ai/api/search-image?query=Professional%20service%20firm%20using%20intelligent%20decision-making%20systems%20and%20data%20analytics%2C%20modern%20business%20intelligence%20dashboard%20with%20clear%20insights%20and%20performance%20metrics%2C%20sophisticated%20corporate%20setting%20with%20technology%20integration%2C%20clean%20professional%20aesthetic%20with%20structured%20information%20display&width=700&height=450&seq=whatwedo-visual-2&orientation=landscape"
              alt="Decision intelligence"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>

        <div className="bg-gray-50 rounded-2xl p-12">
          <h3 className="text-2xl font-bold text-gray-900 mb-8">Our systems are:</h3>
          <div className="grid grid-cols-3 gap-8">
            <div className="flex items-start gap-4">
              <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-1">
                <i className="ri-checkbox-circle-fill text-[#2B6FED] text-xl"></i>
              </div>
              <span className="text-base text-gray-700 font-medium">Purpose-built for professional services</span>
            </div>
            <div className="flex items-start gap-4">
              <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-1">
                <i className="ri-checkbox-circle-fill text-[#2B6FED] text-xl"></i>
              </div>
              <span className="text-base text-gray-700 font-medium">Secure and compliance-aware</span>
            </div>
            <div className="flex items-start gap-4">
              <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-1">
                <i className="ri-checkbox-circle-fill text-[#2B6FED] text-xl"></i>
              </div>
              <span className="text-base text-gray-700 font-medium">Integrated into existing tools and processes</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
